import RequestManager from "../../../../requests/RequestManager";
import StatisticsCountryDetailsTask from "src/requests/tasks/sports/CountryDetails/statisticsCountryDetailsTask";
import { createClassificationResponse, createRankingResponse } from "../../Paises/components/CountryDetailsModal/Components/CountryDetailsBody/Components/StandingsBody/utils";
import { CLASSIFICATION } from "../../Paises/components/CountryDetailsModal/Components/CountryDetailsBody/Components/StandingsBody/constants";
import Utils from "../../../../utils/Utils";
import Translator from "../../../../requests/apa/Translator";
import { title } from "process";

export const getStandingsCountryDetail = async (idLeague, teamViewParam, teamId) => {
	try {
		const statisticsCountryDetailsTask = new StatisticsCountryDetailsTask(idLeague, teamViewParam, teamId);
		const {response} = await RequestManager.addRequest(statisticsCountryDetailsTask);    
        const isClassification = teamViewParam === CLASSIFICATION
        const { teams, headers } = isClassification ? createClassificationResponse(response) : createRankingResponse(response)
        return{
            title: Utils.cutPlayerString(
                    isClassification ? response.teamStatistics.classification[0].group : Translator.get('eventodeportivo_tablaposiciones_fasegrupos_texto_titulo_ranking'),
                    34
                ),
            teams,
            headers
        }
        
		
	} catch (error) {
		console.error('Error getting standings country details:', error);
        return {title: '', teams: [], headers: []}
    }

}


// WEBPACK FOOTER //
// ./src/containers/Mundial2026/services/CountryDetailsServices/getStandingsCountryDetail.js